import React, { FunctionComponent, useEffect, useState } from "react"
import { Grid, Tooltip, Typography } from "@material-ui/core"
import { WarningOutlined } from "@material-ui/icons"
import { BatchPageContext, useBatchPageContext } from "../useBatchPageContext"
import { RecordingAffectOptions } from "./RecordingAffectOptions"
import { Step, useStepControlsContext } from "../../../features/StepControls/useStepControlsContext"
import { StepControls } from "../../../features/StepControls/StepControls"
import { LoadingButton } from "../../../components/LoadingButton"
import { useNeuralVoiceCheck } from "../../../common/hooks/useNeuralVoiceCheck"

export const ReviewAudio: FunctionComponent = props => {
    const { generateAudio, state, allItemsContainAudio } = useBatchPageContext()
    const { activate, deactivate, show } = useStepControlsContext()
    const [loadingGenerated, setLoadingGenerated] = useState(false)
    const isUsingNeural = useNeuralVoiceCheck(BatchPageContext)

    function handleGenerate() {
        setLoadingGenerated(true)
        generateAudio().then(() => {
            setLoadingGenerated(false)
        })
    }

    useEffect(() => {
        if (allItemsContainAudio) {
            activate(Step.NEXT)
        } else {
            deactivate(Step.NEXT)
        }
    }, [state.batchItems])

    useEffect(() => {
        show(Step.NEXT)
        show(Step.BACK)
    }, [])

    const disableGenerateAll = loadingGenerated || state.containsValidationErrors

    return (
        <Grid container spacing={3} direction={"column"} alignItems={"flex-start"}>
            <Grid item data-testid="review-audio-description">
                <Typography variant="caption">
                    Set any desired affect options the click Generate Audio to convert your text to
                    audio
                </Typography>
            </Grid>

            <Grid item>
                <RecordingAffectOptions />
            </Grid>

            <Grid item>
                <Grid container direction="row" spacing={1}>
                    <Grid item>
                        <LoadingButton
                            buttonId={"generate-audio-btn"}
                            disabled={disableGenerateAll}
                            loading={loadingGenerated}
                            text={"Generate All"}
                            onClick={handleGenerate}
                        />
                    </Grid>
                    <Grid item>
                        {isUsingNeural && (
                            <Tooltip
                                title="When using neural voices, audio generation make take longer."
                                placement="right"
                            >
                                <WarningOutlined fontSize="large" htmlColor="gold" />
                            </Tooltip>
                        )}
                    </Grid>
                </Grid>
            </Grid>

            <Grid item>
                <StepControls />
            </Grid>
        </Grid>
    )
}
